module.exports = __webpack_public_path__ + "img/audio.8e34a7a4.svg";